import React, { useEffect } from 'react';
import { createGlobalStyle } from 'styled-components';
import smoothscroll from 'smoothscroll-polyfill';

/* tslint:disable */
// polyfill for Element.closest()
// https://developer.mozilla.org/en-US/docs/Web/API/Element/closest
// if (!Element.prototype.matches) {
//   Element.prototype.matches = (Element as any).prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
// }

// if (!Element.prototype.closest) {
//   Element.prototype.closest = function(s: any) {
//     var el: any = this;

//     do {
//       if (el.matches(s)) return el;
//       el = el.parentElement || el.parentNode;
//     } while (el !== null && el.nodeType === 1);
//     return null;
//   };
// }
/* tslint:enable */

const Reset = createGlobalStyle`
:root {
  --full-screen-height: calc(100vh - (100vh - 100%));
}
blockquote,body,dd,dl,dt,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,html,iframe,legend,li,ol,p,pre,textarea,ul {
  margin: 0;
  padding: 0
}
html {
  font-size: 16px;
  color: #333;
  box-sizing: border-box;
}

body {
  font-size: 1rem;
  font-family: "Inter UI";
}

html, body {
  min-height: 100vh;
}

body.overlay-open {
  overflow: hidden;
}

*,::after,::before { 
  box-sizing:inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;

}

@font-face {
  font-family: 'Inter UI';
  font-style:  normal;
  font-weight: 400;
  font-display: swap;
  src: url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-Regular.woff2") format("woff2"),
       url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-Regular.woff") format("woff");
}

@font-face {
  font-family: 'Inter UI';
  font-style:  normal;
  font-weight: 500;
  font-display: swap;
  src: url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-Medium.woff2") format("woff2"),
       url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-Medium.woff") format("woff");
}

@font-face {
  font-family: 'Inter UI';
  font-style:  normal;
  font-weight: 600;
  font-display: swap;
  src: url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-SemiBold.woff2") format("woff2"),
       url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-SemiBold.woff") format("woff");
}

@font-face {
  font-family: 'Inter UI';
  font-style:  normal;
  font-weight: 700;
  font-display: swap;
  src: url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-Bold.woff2") format("woff2"),
       url("//withjoy.com/assets/public/fonts/inter-ui/Inter-UI-Bold.woff") format("woff");
}
`;

export const GlobalStyle: React.FC = () => {
  useEffect(() => {
    smoothscroll.polyfill();
  }, []);
  return <Reset />;
};
